import { render, staticRenderFns } from "./CongratulationsModal.vue?vue&type=template&id=7bca3125&scoped=true&"
import script from "./CongratulationsModal.vue?vue&type=script&lang=js&"
export * from "./CongratulationsModal.vue?vue&type=script&lang=js&"
import style0 from "./CongratulationsModal.vue?vue&type=style&index=0&id=7bca3125&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bca3125",
  null
  
)

export default component.exports